import React, { useEffect } from 'react';
import './skills.css';
import django from '../../assets/django.png';
import js from '../../assets/js.png';
import py from '../../assets/py.png';
import git from '../../assets/git.png';
import github from '../../assets/github.png';
import wordpress from '../../assets/wordpress.png';
import deluge from '../../assets/deluge.png';
import crm from '../../assets/crm.png';
import react from '../../assets/react.png';
import tail from '../../assets/tail.png';
import vs from '../../assets/vs.png';
import elementor from '../../assets/elementor.png';
import figma from '../../assets/figma.png';
import winscp from '../../assets/winscp.png';
import webflow from '../../assets/webflow.png';
import AOS from 'aos'; // Import AOS
import google from '../../assets/google-a-a.png';
import power from '../../assets/power-bi-1.png';
import zoho from '../../assets/zoho-projects-1.png';
import notion from '../../assets/notion-1-1.png';
import sales from '../../assets/sales-force.png';
import canva from '../../assets/canva.png';
import Marquee from "react-fast-marquee";

const Skills = () => {
  useEffect(() => {
    AOS.init(); // Initialize AOS
  }, []);

  return (
    <section id='skills'>
      <div className='mt-5'>
        <div className='container text-center'>
          <h1 data-aos="fade-up">What <span className="introText">I do</span></h1>
          <p data-aos="fade-up">Experienced Frontend Developer skilled in building responsive, high-performing websites using React.js, Django, HTML, CSS, and JavaScript, along with no-code platforms like WordPress (Elementor), Framer, Webflow, and eCommerce platforms like Shopify. Proficient in integrating and customizing Zoho tools such as CRM, Forms, Analytics, and SalesIQ to enhance customer data management and engagement. I use a range of technologies and tools to achieve this, including.</p>
        </div>
        {/* <div className='col-lg-12 d-flex justify-content-evenly flex-wrap flex-md-nowrap gap-2'>
          <div className='skill-bar p-4' data-aos="fade-up">
            <div className='d-flex align-items-center gap-3'>
              <div className=''><img src={django} alt='' className='django' width="auto" /></div>
              <div className=''>
                <h5>Django</h5>
                <p className='m-0'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat</p>
              </div>
            </div>
          </div>
          <div className='skill-bar p-4' data-aos="fade-up">
            <div className='d-flex align-items-center gap-3'>
              <div className=''><img src={django} alt='' className='django' width="auto" /></div>
              <div className=''>
                <h5>Django</h5>
                <p className='m-0'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat</p>
              </div>
            </div>
          </div>
        </div>
        <div className='col-lg-12 d-flex justify-content-evenly flex-wrap flex-md-nowrap gap-2 mt-2'>
          <div className='skill-bar p-4' data-aos="fade-up">
            <div className='d-flex align-items-center gap-3'>
              <div className=''><img src={django} alt='' className='django' width="auto" /></div>
              <div className=''>
                <h5>Django</h5>
                <p className='m-0'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat</p>
              </div>
            </div>
          </div>
          <div className='skill-bar p-4' data-aos="fade-up">
            <div className='d-flex align-items-center gap-3'>
              <div className=''><img src={django} alt='' className='django' width="auto" /></div>
              <div className=''>
                <h5>Django</h5>
                <p className='m-0'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat</p>
              </div>
            </div>
          </div>
        </div>
        <div className='col-lg-12 d-flex justify-content-evenly flex-wrap flex-md-nowrap gap-2 mt-2'>
          <div className='skill-bar p-4' data-aos="fade-up">
            <div className='d-flex align-items-center gap-3'>
              <div className=''><img src={django} alt='' className='django' width="auto" /></div>
              <div className=''>
                <h5>Django</h5>
                <p className='m-0'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat</p>
              </div>
            </div>
          </div>
          <div className='skill-bar p-4' data-aos="fade-up">
            <div className='d-flex align-items-center gap-3'>
              <div className=''><img src={django} alt='' className='django' width="auto" /></div>
              <div className=''>
                <h5>Django</h5>
                <p className='m-0'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat</p>
              </div>
            </div>
          </div>
        </div> */}
        <div className='mt-5' data-aos="fade-up">
        <h5 className='text-center mb-5'><span className="introText">Technologies</span></h5>
        <Marquee>
        <img src={django} alt='' className='django' width="auto" />
        <img src={js} alt='' className='js' width="auto" />
        <img src={py} alt='' className='py' width="auto" />
        <img src={git} alt='' className='git' width="auto" />
        <img src={wordpress} alt='' className='wordpress' width="auto" />
        {/* <img src={nuxt} alt='' className='nuxt' width="auto" /> */}
        <img src={deluge} alt='' className='deluge' width="auto" />
        <img src={react} alt='' className='react' width="auto" />
        {/* <img src={angular} alt='' className='angular' width="auto" /> */}
        <img src={tail} alt='' className='tail' width="auto" />
        {/* <img src={boot} alt='' className='boot' width="auto" /> */}
        </Marquee>
        </div>
        <div className='mt-5' data-aos="fade-up">
        <h5 className='text-center mb-5'><span className="introText">Tools</span></h5>
        <Marquee direction="right">
        <img src={vs} alt='' className='vs' width="auto" />
        <img src={crm} alt='' className='crm' width="auto" />
        <img src={elementor} alt='' className='elementor' width="auto" />
        <img src={google} alt='' className='google' width="auto" />
        <img src={figma} alt='' className='figma' width="auto" />
        <img src={winscp} alt='' className='winscp' width="auto" />
        <img src={github} alt='' className='github' width="auto" />
        <img src={webflow} alt='' className='webflow' width="auto" />
        <img src={power} alt='' className='power' width="auto" />
        <img src={zoho} alt='' className='zoho' width="auto" />
        <img src={notion} alt='' className='notion' width="auto" />
        <img src={sales} alt='' className='sales' width="auto" />
        <img src={canva} alt='' className='premiere' width="auto" />
        </Marquee>
        </div>
      </div>
    </section>
  );
}

export default Skills;
